const getPopupSlugs = () => {
  const slugs = globalThis.localStorage.getItem('popups') ?? '';
  return new Set(slugs.split(','));
};

const setPopupSlug = (slug: string) => {
  const slugs = globalThis.localStorage.getItem('popups') ?? '';
  const set = new Set(slugs.split(','));
  set.add(slug);
  globalThis.localStorage.setItem('popups', [...set].join(','));
};

export { getPopupSlugs, setPopupSlug };
